import enUS from './GE';

const messages = {
  'en-US': enUS
};

export default messages;